<template>
    <div class="text-center">
        <div class="text-h6 font-weight-bold">
          {{ event.TimeDisplay }}
        </div>

        <div
          v-if="event.Delayed"
          class="orange--text details"
        >Delayed</div>  

        <div
          v-else-if="event.Postponed"
          class="red--text details"
        >Postponed</div>

        <div
          v-else-if="event.Cancelled"
          class="red--text details"
        >Cancelled</div>

        
        
        <div 
          v-if="!event.Live"
          class="details">
          {{ event.Highlights ? ' highlights from ' : ' replay from ' }}
          <br />
          {{ eventDate(event.DateTime) }}
        </div>
    </div>
</template>

<script>
export default {
  name: "TimeDisplay",
  props: {
    event: Object,
  },
  methods: {
    eventDate: function (eventDateTime) {
      let dateTime = moment(eventDateTime);
      return dateTime.format("l");
    },
  },
};
</script>

<style scoped>
.details {
  font-size: 0.7rem;
  height: 10px;
}
</style>